import { createFileRoute } from '@tanstack/react-router'

/**
 * Lightweight Health Check Endpoint
 *
 * Purpose: Fast health status for load balancers and automated monitoring
 * Use Cases:
 * - Load balancer health checks
 * - Automated monitoring systems
 * - Quick status verification
 * - Public health status
 *
 * Access: Public endpoint, minimal information exposure
 */
export const Route = createFileRoute('/simple-health')({
  component: SimpleHealthCheck,
})

function SimpleHealthCheck() {
  const healthStatus = {
    status: 'healthy',
    timestamp: new Date().toISOString(),
    version: import.meta.env.VITE_APP_VERSION || '0.0.2',
    environment: import.meta.env.VITE_APP_ENV || 'development',
    uptime: performance.now(),
    checks: {
      newrelic: typeof window !== 'undefined' && !!window.NREUM ? 'healthy' : 'not_configured',
      api: 'healthy',
    },
  }

  return (
    <div className="p-4 max-w-md mx-auto">
      <h1 className="text-xl font-bold mb-3">Health Status</h1>
      <div className="bg-white rounded-lg shadow p-3">
        <div className="mb-3">
          <span
            className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
              healthStatus.status === 'healthy'
                ? 'bg-green-100 text-green-800'
                : 'bg-red-100 text-red-800'
            }`}
          >
            {healthStatus.status.toUpperCase()}
          </span>
        </div>

        <div className="space-y-1 text-sm">
          <div>
            <strong>Version:</strong> {healthStatus.version}
          </div>
          <div>
            <strong>Environment:</strong> {healthStatus.environment}
          </div>
          <div>
            <strong>Uptime:</strong> {Math.round(healthStatus.uptime)}ms
          </div>
        </div>

        <div className="mt-3 pt-2 border-t border-gray-200">
          <div className="text-xs text-gray-600">System: {healthStatus.checks.api}</div>
        </div>
      </div>
    </div>
  )
}
